<template>
  <login-message-box
    title="Password Expired"
    buttonLabel="Login"
    :action="handleLogin"
  >
    Your password has expired.  Please logging in again and clicking
    on <strong>Forgot password?</strong> to trigger a password reset.
  </login-message-box>
</template>

<script>
import { getAuthInstance } from "@/auth/authService";
import LoginMessageBox from "@/views/components/auth/LoginMessageBox";

export default {
  name: "PasswordExpired",
  components: {
    LoginMessageBox,
  },
  methods: {
    handleLogin() {
      const auth = getAuthInstance();
      auth.logout();
    },
  },
};
</script>